function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/nonIterableSpread.js
// module id = 437
// module chunks = 0